import { el } from '../core/dom.js';

/** @param {{ title: string, message: string, action?: Node }} opts */
export function errorPanel(opts) {
  return el('div', { class: 'error-panel', role: 'alert' },
    el('p', { class: 'kicker' }, 'Error'),
    el('h2', { class: 'empty-title' }, opts.title),
    el('p', { class: 'empty-body' }, opts.message),
    opts.action || null);
}
